import { Box } from '@mui/material';
import React from 'react'
import MyMessages from '../../component/MyMessages';
import Header from '../../component/Header';


const Conversetion = () => {
    return (
        <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
    
        <Header />
        <Box component="main" className="MainContent" sx={{ flex: 1 }}>
          <MyMessages />
        </Box>
      </Box>
    )
}

export default Conversetion;